
import { PaginacionProps } from "../global/PaginacionInterface";
import { ExpedienteProps, defaultExpediente } from "../recepcion/ExpedienteInterface";
import { AmparoProps, defaultAmparo } from "../recepcion/AmparoInterface";

export const defaultBuscarLibroAmparoResponse: BuscarLibroAmparoResponse = { currentPageIndex: 0, pageCount: 0, recordCount: 0, records: [] };

export const defaultBuscarLibroAmparo: BuscarLibroAmparo = { idAutoridad: 0, numeroReferencia: '', idTipoConsecutivo: 0 };

export const defaultLibroAmparo: LibroAmparoProps = {
    idLibroAmparo:              0,
    idAmparo:                   0,
    numeroAmparo:               '',
    numeroAmparoOrigen:         '',
    quejoso:                    '',
    idExpediente:               0,
    numeroExpediente:           '',
    tipoAmparo:                 '',
    autoridadAmparo:            '',
    observaciones:              '',
    expediente:                 defaultExpediente,
    amparo:                     defaultAmparo,
};


export interface LibroAmparoProps {
    idLibroAmparo:              number;
    idAmparo:                   number;
    numeroAmparo:               string;
    numeroAmparoOrigen:         string;
    quejoso:                    string;
    idExpediente:               number;
    numeroExpediente:           string;
    tipoAmparo:                 string;
    autoridadAmparo:            string;
    fecha?:                     Date;
    observaciones:              string;
    expediente:                 ExpedienteProps;
    amparo:                     AmparoProps;
}

export interface BuscarLibroAmparo {
    idAutoridad:                number;
    numeroReferencia:           string;
    idTipoConsecutivo?:         number;
}

export interface BuscarLibroAmparoParams extends PaginacionProps, BuscarLibroAmparo { }

export interface BuscarLibroAmparoResponse {
    currentPageIndex:           number;
    pageCount:                  number;
    recordCount:                number;
    records:                    LibroAmparoProps[];
}

export interface GuardarObservaciones {
    id:                         number;
    observaciones:              string;
}

export interface DescargarInformacionParams {
    idAutoridad:                number;
    numeroReferencia:           string;
    idTipoConsecutivo?:         number;
}